import TumengLineEdit from './src/index.vue'

TumengLineEdit.install = function(Vue) {
  Vue.component(TumengLineEdit.name, TumengLineEdit)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengLineEdit)
}

export default TumengLineEdit
